"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_styles_1 = require("@/components/common/icon/icon.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const ICONOIR_STYLESHEET_URL = 'https://cdn.jsdelivr.net/gh/iconoir-icons/iconoir@main/css/iconoir.css';
// mm-icon은 shadow DOM 안에서 렌더되므로 document의 전역 Iconoir CSS를 직접 사용할 수 없다.
// 각 인스턴스가 <link>를 만들지 않도록 CSS를 한 번만 가져와 공유 stylesheet로 재사용한다.
let iconoirStylesheetPromise = null;
const loadIconoirStylesheet = () => {
    if (iconoirStylesheetPromise)
        return iconoirStylesheetPromise;
    iconoirStylesheetPromise = (async () => {
        if (!('adoptedStyleSheets' in Document.prototype) || !('CSSStyleSheet' in window))
            return null;
        try {
            const response = await fetch(ICONOIR_STYLESHEET_URL);
            if (!response.ok)
                return null;
            const stylesheet = new CSSStyleSheet();
            await stylesheet.replace(await response.text());
            return stylesheet;
        }
        catch {
            return null;
        }
    })();
    return iconoirStylesheetPromise;
};
let Icon = class Icon extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.size = 'medium';
        this.useStylesheetLink = false;
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderStylesheetLink()}
      <i class=${this.iconClassName}></i>
    `;
    }
    get iconClassName() {
        if (!this.name)
            return 'icon';
        return `icon iconoir-${this.name}`;
    }
    renderStylesheetLink() {
        if (!this.useStylesheetLink)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <link rel="stylesheet" href=${ICONOIR_STYLESHEET_URL} />
    `;
    }
    firstUpdated() {
        void this.adoptIconoirStylesheet();
    }
    async adoptIconoirStylesheet() {
        const stylesheet = await loadIconoirStylesheet();
        // constructable stylesheet를 쓸 수 없거나 CDN fetch가 실패하면 기존 link 방식으로 돌아간다.
        if (!stylesheet || !(this.renderRoot instanceof ShadowRoot)) {
            this.useStylesheetLink = true;
            return;
        }
        if (this.renderRoot.adoptedStyleSheets.includes(stylesheet))
            return;
        this.renderRoot.adoptedStyleSheets = [...this.renderRoot.adoptedStyleSheets, stylesheet];
    }
};
Icon.styles = [shared_styles_1.resetStyles, icon_styles_1.iconStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Icon.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Icon.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.state)()
], Icon.prototype, "useStylesheetLink", void 0);
Icon = __decorate([
    (0, decorators_js_1.customElement)('mm-icon')
], Icon);
exports.Icon = Icon;
//# sourceMappingURL=data:application/json;base64,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